import { produce, Draft } from 'immer'
import { TActionTypes, IAction } from '@Root/types'

import {
  PopupActionTypes,
  TPopupActionTypes,
  IPopupState,
  IOpenExternalTokenPopupPayload,
  IOpenProjectSharingPopupPayload,
  IOpenImportSrtPopupPayload,
  IOpenDeleteProjectPopupPayload,
  IOpenDeleteProjectVersionPopupPayload,
  IOpenRenameProjectPopupPayload,
  IOpenRenameProjectVersionPopupPayload,
  IOpenExportationPopupPayload,
  IOpenRenameLabelPopupPayload,
  IOpenDeleteLabelPopupPayload,
  IOpenSetupProjectPopupPayload,
  IOpenSetupProjectPopupTtsPayload,
  IOpenDeleteWorkspacePopupPayload,
  IOpenRemoveSpeakerVoicePopupPayload,
  IOpenVoiceTypeUpgradePopupPayload,
  ISetEditingProjectIdsPayload,
} from './types'

import {
  AccountActionTypes,
} from '@SiteModules/Account/types'

export const initialState: IPopupState = {
  openCreateLabelPopup: false,
  openDeleteLabelPopup: false,
  openRenameLabelPopup: false,
  openImportSrtPopup: false,
  openDeleteProjectPopup: false,
  openDeleteProjectVersionPopup: false,
  openRenameProjectPopup: false,
  openRenameProjectVersionPopup: false,
  openExportationPopup: false,
  openExternalTokenPopup: false,
  openProjectSharingPopup: false,
  openAccountPopup: false,
  openNewProjectPopup: false,
  openSetupProjectPopup: false,
  openSetupProjectPopupTts: false,
  openLabelsManagerPopup: false,
  openNewsletterPopup: false,
  openMoveToOtherWorkspacePopup: false,
  openDeleteWorkspacePopup: false,
  openCreateWorkspacePopup: false,
  openCreateAccountUserPopup: false,
  openManageWorkspaceAccessPopup: false,
  voiceTypeUpgradePopupLabel: null,
  openRemoveSpeakerVoicePopup: false,
  openImportTermsPopup: false,
  openRenewSubscriptionPopup: false,
  editingSubtitleIds: [],
  editingProjectIds: [],
  editingProjectVersionIds: [],
  editingSpeakerVoiceIds: [],
  editingLabelId: -1,
  editingLabelCaption: '',
  projectType: '',
  editingWorkspaceIds: [],
  includePublicLink: undefined,
}

type TAction = TActionTypes | TPopupActionTypes

export const popupReducer = (
  state: IPopupState = initialState,
  action: TAction
): IPopupState => {
  return produce(state, draft => {
    switch (action.type) {
      case PopupActionTypes.CLOSE_DASHBOARD_POPUPS:
      case AccountActionTypes.SET_CURRENT_ACCOUNT:
        closeDashboardPopups(draft)
        break

      case PopupActionTypes.CLOSE_LABEL_POPUPS:
        closeLabelPopups(draft)
        break

      case PopupActionTypes.CLOSE_VOICE_STUDIO_POPUPS:
        closeVoiceStudioPopups(draft)
        break

      case PopupActionTypes.OPEN_DELETE_LABEL_POPUP:
        openDeleteLabelPopup(draft, action)
        break

      case PopupActionTypes.OPEN_RENAME_LABEL_POPUP:
        openRenameLabelPopup(draft, action)
        break

      case PopupActionTypes.OPEN_CREATE_LABEL_POPUP:
        openCreateLabelPopup(draft)
        break

      case PopupActionTypes.OPEN_IMPORT_SRT_POPUP:
        openImportSrtPopup(draft, action)
        break

      case PopupActionTypes.OPEN_DELETE_PROJECT_POPUP:
        openDeleteProjectPopup(draft, action)
        break

      case PopupActionTypes.OPEN_DELETE_PROJECT_VERSION_POPUP:
        openDeleteProjectVersionPopup(draft, action)
        break

      case PopupActionTypes.OPEN_RENAME_PROJECT_POPUP:
        openRenameProjectPopup(draft, action)
        break

      case PopupActionTypes.OPEN_RENAME_PROJECT_VERSION_POPUP:
        openRenameProjectVersionPopup(draft, action)
        break

      case PopupActionTypes.OPEN_EXPORTATION_POPUP:
        openExportationPopup(draft, action)
        break

      case PopupActionTypes.OPEN_EXTERNAL_TOKEN_POPUP:
        openExternalTokenPopup(draft, action)
        break

      case PopupActionTypes.OPEN_PROJECT_SHARING_POPUP:
        openProjectSharingPopup(draft, action)
        break

      case PopupActionTypes.OPEN_NEW_PROJECT_POPUP:
        openNewProjectPopup(draft)
        break

      case PopupActionTypes.OPEN_SETUP_PROJECT_POPUP:
        openSetupProjectPopup(draft, action)
        break

      case PopupActionTypes.CLOSE_SETUP_PROJECT_POPUP:
        closeSetupProjectPopup(draft)
        break

      case PopupActionTypes.OPEN_SETUP_PROJECT_POPUP_TTS:
        openSetupProjectPopupTts(draft, action)
        break

      case PopupActionTypes.CLOSE_SETUP_PROJECT_POPUP_TTS:
        closeSetupProjectPopupTts(draft)
        break

      case PopupActionTypes.OPEN_ACCOUNT_POPUP:
        openAccountPopup(draft)
        break

      case PopupActionTypes.CLOSE_ACCOUNT_POPUP:
        closeAccountPopup(draft)
        break

      case PopupActionTypes.OPEN_LABELS_MANAGER_POPUP:
        openLabelsManagerPopup(draft)
        break

      case PopupActionTypes.CLOSE_LABELS_MANAGER_POPUP:
        closeLabelsManagerPopup(draft)
        break

      case PopupActionTypes.OPEN_NEWSLETTER_POPUP:
        openNewsletterPopup(draft)
        break

      case PopupActionTypes.CLOSE_NEWSLETTER_POPUP:
        closeNewsletterPopup(draft)
        break

      case PopupActionTypes.OPEN_DELETE_WORKSPACE_POPUP:
        openDeleteWorkspacePopup(draft, action)
        break

      case PopupActionTypes.CLOSE_DELETE_WORKSPACE_POPUP:
        closeDeleteWorkspacePopup(draft)
        break

      case PopupActionTypes.OPEN_CREATE_WORKSPACE_POPUP:
        openCreateWorkspacePopup(draft)
        break

      case PopupActionTypes.CLOSE_CREATE_WORKSPACE_POPUP:
        closeCreateWorkspacePopup(draft)
        break

      case PopupActionTypes.OPEN_CREATE_ACCOUNT_USER_POPUP:
        openCreateAccountUserPopup(draft)
        break

      case PopupActionTypes.CLOSE_CREATE_ACCOUNT_USER_POPUP:
        closeCreateAccountUserPopup(draft)
        break

      case PopupActionTypes.OPEN_VOICE_TYPE_UPGRADE_POPUP:
        openVoiceTypeUpgradePopup(draft, action)
        break

      case PopupActionTypes.CLOSE_VOICE_TYPE_UPGRADE_POPUP:
        closeVoiceTypeUpgradePopup(draft)
        break

      case PopupActionTypes.OPEN_MANAGE_WORKSPACE_ACCESS_POPUP:
        openManageWorkspaceAccessPopup(draft)
        break

      case PopupActionTypes.CLOSE_MANAGE_WORKSPACE_ACCESS_POPUP:
        closeManageWorkspaceAccessPopup(draft)
        break

      case PopupActionTypes.OPEN_REMOVE_SPEAKER_VOICE_POPUP:
        openRemoveSpeakerVoicePopup(draft, action)
        break

      case PopupActionTypes.CLOSE_REMOVE_SPEAKER_VOICE_POPUP:
        closeRemoveSpeakerVoicePopup(draft)
        break

      case PopupActionTypes.OPEN_IMPORT_TERMS_POPUP:
        openImportTermsPopup(draft)
        break

      case PopupActionTypes.CLOSE_IMPORT_TERMS_POPUP:
        closeImportTermsPopup(draft)
        break

      case PopupActionTypes.OPEN_MOVE_TO_OTHER_WORKSPACE_POPUP:
        openMoveToOtherWorkspacePopup(draft)
        break

      case PopupActionTypes.CLOSE_MOVE_TO_OTHER_WORKSPACE_POPUP:
        closeMoveToOtherWorkspacePopup(draft)
        break

      case PopupActionTypes.OPEN_RENEW_SUBSCRIPTION_POPUP:
        openRenewSubscriptionPopup(draft)
        break

      case PopupActionTypes.CLOSE_RENEW_SUBSCRIPTION_POPUP:
        closeRenewSubscriptionPopup(draft)
        break

      case PopupActionTypes.SET_EDITING_PROJECT_IDS:
        setEditingProjectIds(draft, action)
        break

      default:
        break
    }
  })
}

const closeDashboardPopups = (draft: Draft<IPopupState>) => {
  draft.openImportSrtPopup = false
  draft.openDeleteProjectPopup = false
  draft.openDeleteProjectVersionPopup = false
  draft.openRenameProjectPopup = false
  draft.openRenameProjectVersionPopup = false
  draft.openExportationPopup = false
  draft.openExternalTokenPopup = false
  draft.openProjectSharingPopup = false
  draft.openNewProjectPopup = false
  draft.openLabelsManagerPopup = false
  draft.openMoveToOtherWorkspacePopup = false
  draft.openRenewSubscriptionPopup = false
  draft.editingSubtitleIds = []
  draft.editingProjectIds = []
  draft.editingProjectVersionIds = []
  draft.includePublicLink = undefined
}

const closeLabelPopups = (draft: Draft<IPopupState>) => {
  draft.openCreateLabelPopup = false
  draft.openRenameLabelPopup = false
  draft.openDeleteLabelPopup = false
  draft.editingLabelId = -1
  draft.editingLabelCaption = ''
}

const closeVoiceStudioPopups = (draft: Draft<IPopupState>) => {
  draft.openRemoveSpeakerVoicePopup = false
  draft.editingSpeakerVoiceIds = []
}

const openCreateLabelPopup = (draft: Draft<IPopupState>) => {
  draft.openCreateLabelPopup = true
}

function isIOpenDeleteLabelPopupAction(arg: any): arg is IAction<IOpenDeleteLabelPopupPayload> {
  return arg.type === PopupActionTypes.OPEN_DELETE_LABEL_POPUP
}

const openDeleteLabelPopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenDeleteLabelPopupAction(action)) { return }

  draft.editingLabelId = action.payload.labelId
  draft.editingLabelCaption = action.payload.caption
  draft.openDeleteLabelPopup = true
}

function isIOpenRenameLabelPopupAction(arg: any): arg is IAction<IOpenRenameLabelPopupPayload> {
  return arg.type === PopupActionTypes.OPEN_RENAME_LABEL_POPUP
}

const openRenameLabelPopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenRenameLabelPopupAction(action)) { return }

  draft.editingLabelId = action.payload.labelId
  draft.editingLabelCaption = action.payload.caption
  draft.openRenameLabelPopup = true
}

function isIOpenImportSrtPopupAction(arg: any): arg is IAction<IOpenImportSrtPopupPayload> {
  return arg.type === PopupActionTypes.OPEN_IMPORT_SRT_POPUP
}

const openImportSrtPopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenImportSrtPopupAction(action)) { return }

  draft.editingSubtitleIds = [action.payload.subtitleId]
  draft.editingProjectVersionIds = [action.payload.projectVersionId]
  draft.openImportSrtPopup = true
}

function isIOpenDeleteProjectPopupAction(arg: any): arg is IAction<IOpenDeleteProjectPopupPayload> {
  return arg.type === PopupActionTypes.OPEN_DELETE_PROJECT_POPUP
}

const openDeleteProjectPopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenDeleteProjectPopupAction(action)) { return }

  draft.editingProjectIds = action.payload.projectIds
  draft.openDeleteProjectPopup = true
}

function isIOpenDeleteProjectVersionPopupAction(arg: any): arg is IAction<IOpenDeleteProjectVersionPopupPayload> {
  return arg.type === PopupActionTypes.OPEN_DELETE_PROJECT_VERSION_POPUP
}

const openDeleteProjectVersionPopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenDeleteProjectVersionPopupAction(action)) { return }

  draft.editingProjectVersionIds = action.payload.projectVersionIds
  draft.openDeleteProjectVersionPopup = true
}

function isIOpenRenameProjectPopupAction(arg: any): arg is IAction<IOpenRenameProjectPopupPayload> {
  return arg.type === PopupActionTypes.OPEN_RENAME_PROJECT_POPUP
}

const openRenameProjectPopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenRenameProjectPopupAction(action)) { return }

  draft.editingProjectIds = [action.payload.projectId]
  draft.openRenameProjectPopup = true
}

function isIOpenRenameProjectVersionPopupAction(arg: any): arg is IAction<IOpenRenameProjectVersionPopupPayload> {
  return arg.type === PopupActionTypes.OPEN_RENAME_PROJECT_VERSION_POPUP
}

const openRenameProjectVersionPopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenRenameProjectVersionPopupAction(action)) { return }

  draft.editingProjectVersionIds = [action.payload.projectVersionId]
  draft.openRenameProjectVersionPopup = true
}

function isIOpenExportationPopupAction(arg: any): arg is IAction<IOpenExportationPopupPayload> {
  return arg.type === PopupActionTypes.OPEN_EXPORTATION_POPUP
}

const openExportationPopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenExportationPopupAction(action)) { return }

  draft.editingProjectIds = action.payload.projectIds
  draft.openExportationPopup = true
}

function isIOpenExternalTokenPopupAction(arg: any): arg is IAction<IOpenExternalTokenPopupPayload> {
  return arg.type === PopupActionTypes.OPEN_EXTERNAL_TOKEN_POPUP
}

const openExternalTokenPopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenExternalTokenPopupAction(action)) { return }

  draft.editingSubtitleIds = [action.payload.subtitleId]
  draft.openExternalTokenPopup = true
}

function isIOpenProjectSharingPopupAction(arg: any): arg is IAction<IOpenProjectSharingPopupPayload> {
  return arg.type === PopupActionTypes.OPEN_PROJECT_SHARING_POPUP
}

const openProjectSharingPopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenProjectSharingPopupAction(action)) { return }

  draft.editingProjectIds = action.payload.projectIds
  draft.editingSubtitleIds = action.payload.subtitleId ? [action.payload.subtitleId] : []
  draft.includePublicLink = action.payload.includePublicLink
  draft.openProjectSharingPopup = true
}

const openNewProjectPopup = (draft: Draft<IPopupState>) => {
  draft.openNewProjectPopup = true
}

function isIOpenSetupProjectPopupAction(arg: any): arg is IAction<IOpenSetupProjectPopupPayload> {
  return arg.type === PopupActionTypes.OPEN_SETUP_PROJECT_POPUP
}

const openSetupProjectPopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenSetupProjectPopupAction(action)) { return }

  draft.openSetupProjectPopup = true
  draft.editingProjectVersionIds = action.payload.projectVersionIds

  if (action.payload.projectType) {
    draft.projectType = action.payload.projectType
  }
}

const closeSetupProjectPopup = (draft: Draft<IPopupState>) => {
  draft.openNewProjectPopup = false
  draft.openSetupProjectPopup = false
  draft.editingProjectVersionIds = []
  draft.projectType = ''
}

function isIOpenSetupProjectPopupTtsAction(arg: any): arg is IAction<IOpenSetupProjectPopupTtsPayload> {
  return arg.type === PopupActionTypes.OPEN_SETUP_PROJECT_POPUP_TTS
}

const openSetupProjectPopupTts = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenSetupProjectPopupTtsAction(action)) { return }

  draft.openSetupProjectPopupTts = true
  draft.editingProjectVersionIds = action.payload.projectVersionIds
}

const closeSetupProjectPopupTts = (draft: Draft<IPopupState>) => {
  draft.openNewProjectPopup = false
  draft.openSetupProjectPopupTts = false
  draft.editingProjectVersionIds = []
}

const openAccountPopup = (draft: Draft<IPopupState>) => {
  draft.openAccountPopup = true
}

const closeAccountPopup = (draft: Draft<IPopupState>) => {
  draft.openAccountPopup = false
}

const openLabelsManagerPopup = (draft: Draft<IPopupState>) => {
  draft.openLabelsManagerPopup = true
}

const closeLabelsManagerPopup = (draft: Draft<IPopupState>) => {
  draft.openLabelsManagerPopup = false
}

const openNewsletterPopup = (draft: Draft<IPopupState>) => {
  draft.openNewsletterPopup = true
}

const closeNewsletterPopup = (draft: Draft<IPopupState>) => {
  draft.openNewsletterPopup = false
}

function isIOpenDeleteWorkspacePopupAction(arg: any): arg is IAction<IOpenDeleteWorkspacePopupPayload> {
  return arg.type === PopupActionTypes.OPEN_DELETE_WORKSPACE_POPUP
}

const openDeleteWorkspacePopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenDeleteWorkspacePopupAction(action)) { return }

  draft.openDeleteWorkspacePopup = true
  draft.editingWorkspaceIds = action.payload.workspaceIds
}

const closeDeleteWorkspacePopup = (draft: Draft<IPopupState>) => {
  draft.openDeleteWorkspacePopup = false
  draft.editingWorkspaceIds = []
}

const openCreateWorkspacePopup = (draft: Draft<IPopupState>) => {
  draft.openCreateWorkspacePopup = true
}

const closeCreateWorkspacePopup = (draft: Draft<IPopupState>) => {
  draft.openCreateWorkspacePopup = false
}

const openCreateAccountUserPopup = (draft: Draft<IPopupState>) => {
  draft.openCreateAccountUserPopup = true
}

const closeCreateAccountUserPopup = (draft: Draft<IPopupState>) => {
  draft.openCreateAccountUserPopup = false
}

function isIOpenVoiceTypeUpgradePopupAction(arg: any): arg is IAction<IOpenVoiceTypeUpgradePopupPayload> {
  return arg.type === PopupActionTypes.OPEN_VOICE_TYPE_UPGRADE_POPUP
}

const openVoiceTypeUpgradePopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenVoiceTypeUpgradePopupAction(action)) { return }

  draft.voiceTypeUpgradePopupLabel = action.payload.voiceType
}

const closeVoiceTypeUpgradePopup = (draft: Draft<IPopupState>) => {
  draft.voiceTypeUpgradePopupLabel = null
}

const openManageWorkspaceAccessPopup = (draft: Draft<IPopupState>) => {
  draft.openManageWorkspaceAccessPopup = true
}

const closeManageWorkspaceAccessPopup = (draft: Draft<IPopupState>) => {
  draft.openManageWorkspaceAccessPopup = false
}

function isIOpenRemoveSpeakerVoicePopupAction(arg: any): arg is IAction<IOpenRemoveSpeakerVoicePopupPayload> {
  return arg.type === PopupActionTypes.OPEN_REMOVE_SPEAKER_VOICE_POPUP
}

const openRemoveSpeakerVoicePopup = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isIOpenRemoveSpeakerVoicePopupAction(action)) { return }

  draft.editingSpeakerVoiceIds = action.payload.speakerVoiceIds
  draft.openRemoveSpeakerVoicePopup = true
}

const closeRemoveSpeakerVoicePopup = (draft: Draft<IPopupState>) => {
  draft.editingSpeakerVoiceIds = []
  draft.openRemoveSpeakerVoicePopup = false
}

const openImportTermsPopup = (draft: Draft<IPopupState>) => {
  draft.openImportTermsPopup = true
}

const closeImportTermsPopup = (draft: Draft<IPopupState>) => {
  draft.openImportTermsPopup = false
}

const openMoveToOtherWorkspacePopup = (draft: Draft<IPopupState>) => {
  draft.openMoveToOtherWorkspacePopup = true
}

const closeMoveToOtherWorkspacePopup = (draft: Draft<IPopupState>) => {
  draft.openMoveToOtherWorkspacePopup = false
}

const openRenewSubscriptionPopup = (draft: Draft<IPopupState>) => {
  draft.openRenewSubscriptionPopup = true
}

const closeRenewSubscriptionPopup = (draft: Draft<IPopupState>) => {
  draft.openRenewSubscriptionPopup = false
}

function isISetEditingProjectIdsAction(arg: any): arg is IAction<ISetEditingProjectIdsPayload> {
  return arg.type === PopupActionTypes.SET_EDITING_PROJECT_IDS
}

const setEditingProjectIds = (draft: Draft<IPopupState>, action: TAction) => {
  if (!isISetEditingProjectIdsAction(action)) { return }

  draft.editingProjectIds = action.payload.updatedEditingProjectIds
}
